import React from "react";
import { Icon } from "../../../core/Icon";
import { phpBool } from "../../../core/Helpers";
import { getEventState, EEventTimeState } from "../../common/event/EventHelper";
export const Attendees = (props) => {
    const { attendees, eventData } = props;
    const eventState = getEventState(eventData);
    return React.createElement("div", { className: "ed-attendees" },
        React.createElement("h2", { className: "h4" }, "Schv\u00E1len\u00ED \u00FA\u010Dastn\u00EDci"),
        (eventState.timeState == EEventTimeState.ToBe) ?
            React.createElement("div", { className: "text-muted" }, "Po zah\u00E1jen\u00ED aukce bude zobrazen seznam \u00FA\u010Dastn\u00EDk\u016F, kte\u0159\u00ED splnili podm\u00EDnky pro \u00FA\u010Dast.")
            :
                React.createElement(React.Fragment, null,
                    attendees && attendees.map((att, key) => {
                        return React.createElement("div", { className: "ed-att", key: key },
                            React.createElement(Icon, { c: ['user', 12, 12] }),
                            React.createElement("span", { className: "mr-8" },
                                "\u00DA\u010Dastn\u00EDk \u010D.",
                                att.id),
                            phpBool(att.preemptive) && React.createElement("span", { className: "text-muted" }, "p\u0159edkupn\u00ED pr\u00E1vo"));
                    }),
                    attendees && attendees.length == 0 && React.createElement("div", { className: "text-muted" }, "\u017D\u00E1dn\u00ED \u00FA\u010Dastn\u00EDci")));
};
